import {type PaletteOptions} from '@mui/material/styles';

export const ThemeLightPalette: PaletteOptions = {
  mode: 'light',
  background: {
    default: '#F1F1F1 !important',
    paper: '#fff !important',
  },
  text: {
    primary: '#1a1a1a !important',
    secondary: '#333333 !important',
    disabled: '#777777 !important',
  },
  primary: {
    light: '#F7B27A',
    main: '#f26722',
    dark: '#B93815',
    contrastText: '#fff',
  },
  secondary: {
    main: '#4d4d4d !important',
    contrastText: '#fff !important',
  },
};
